<template>
	<div v-show="fieldList.length" class="custom-detail flex-wrap">
		<c-detail-item v-for="(item, i) in fieldList" :key="i" :label="item.field_title" :tip="item.config_json.tip">
			<template v-if="data">
				<c-file-list v-if="['image', 'file'].includes(item.config_json.type)" :value="data[item.field_code].value" :media="false"></c-file-list>
				<c-tags v-else-if="typeof data[item.field_code].value == 'object'" :value="data[item.field_code].value"></c-tags>
				<div v-else-if="['text', 'formula'].includes(item.config_json.type) && item.config_json.attr.includes('textarea')" style="max-height: 65px; overflow: auto; white-space: pre-wrap;">{{data[item.field_code].value || '-'}}</div>
				<span v-else-if="item.config_json.type == 'rel_object'">{{data[item.field_code].display_value || '-'}}</span>
				<span v-else>{{data[item.field_code].value || '-'}}</span>
			</template>
		</c-detail-item>
	</div>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		name: 'customDetail',

		props: {
			workType: [String, Number],
			data: Object
		},

		computed: {
			...mapState(['customField']),

			fieldList() {
				return this.customField[this.workType] || [];
			}
		},

		mounted() {
			this.$store.dispatch('updateFieldConfig');
		}
	}
</script>

<style lang="stylus" scoped>
	.custom-detail {
		width: 100%;
	}
</style>
